// Tiene que ser https: el sitio va por HTTPS y el navegador bloquea un POST
// a http:// por mixed content. El backend todavia no existe en este dominio.
export const UPLOAD_URL = "https://api.marcosyclari.com/confirm"